import { registerRequiredFieldErrorMap } from "@9amhealth/shared/src/lib/zod";
import translate from "src/lib/translate";

/**
 * Zod's default issue messages are English, and AutoForm renders them verbatim,
 * so they leak into the UI untranslated for Spanish users (FEWEB-2535). Resolve
 * the missing-value message through i18next instead — `translate` runs at parse
 * time, so errors always match the language that is active right now.
 */
export default function registerTranslatedZodErrorMap(): void {
  registerRequiredFieldErrorMap(() => translate("required"));
}
